import styled from 'styled-components';

export const PriorityWrapper = styled.div`
    display: flex;
    padding: 0.4rem 0;
`;
